import {
  ActionType,
  IMentalCheckTypeListResponse,
} from "models/mentalHealth/typeList";

export const getTypeListAction = () => {
  return {
    type: ActionType.MENTAL_CHECK_TYPE_LIST,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.MENTAL_CHECK_TYPE_LIST_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IMentalCheckTypeListResponse) => {
  return {
    type: ActionType.MENTAL_CHECK_TYPE_LIST_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.MENTAL_CHECK_TYPE_LIST_RESET_DATA,
  };
};
